import useGetEmailCreationTypes from 'email-management-lib/EmailCreation/hooks/useGetEmailCreationOptions';
import EmailOptionButton from './EmailOptionButton';
import useEmailSelectedOptionState from '../../hooks/useEmailSelectedOptionState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import useGetCurrentBusinessUnit, { ALL_BU_SELECTED, DEFAULT_BU_ID } from 'messaging-management-lib/portal/hooks/useGetCurrentBusinessUnit';
import { useMemo } from 'react';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BusinessUnitTagWithDF = WithBusinessUnitsDataFetching(BusinessUnitTag);
const StyledSection = styled.div.withConfig({
  displayName: "EmailOptionSelect__StyledSection",
  componentId: "nxzxo7-0"
})(["&:first-child{margin-bottom:24px;}"]);
const StyledTitle = styled.span.withConfig({
  displayName: "EmailOptionSelect__StyledTitle",
  componentId: "nxzxo7-1"
})(["display:inline-block;font-size:14px;font-weight:500;margin-bottom:8px;"]);
const BusinessUnitTagWrapper = styled.div.withConfig({
  displayName: "EmailOptionSelect__BusinessUnitTagWrapper",
  componentId: "nxzxo7-2"
})(["height:32px;"]);
export default function EmailOptionSelect() {
  const {
    selectedOption,
    setSelectedOption
  } = useEmailSelectedOptionState();
  const emailCreationTypes = useGetEmailCreationTypes();
  const currentBusinessUnitID = useGetCurrentBusinessUnit();
  const businessUnitIDToUse = useMemo(() => {
    if (currentBusinessUnitID === null) return null;
    if (currentBusinessUnitID === ALL_BU_SELECTED) return DEFAULT_BU_ID;
    return currentBusinessUnitID;
  }, [currentBusinessUnitID]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [businessUnitIDToUse !== null && /*#__PURE__*/_jsxs(StyledSection, {
      children: [/*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
          message: "email-management-creation.createEmailPanel.businessUnitTooltip",
          rebrandMessage: "email-management-creation.createEmailPanel.businessUnitTooltip_buv2"
        }),
        children: /*#__PURE__*/_jsx(StyledTitle, {
          children: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
            message: "email-management-creation.createEmailPanel.businessUnit",
            rebrandMessage: "email-management-creation.createEmailPanel.businessUnit_buv2"
          })
        })
      }), /*#__PURE__*/_jsx(BusinessUnitTagWrapper, {
        children: /*#__PURE__*/_jsx(BusinessUnitTagWithDF, {
          buId: businessUnitIDToUse
        })
      })]
    }), /*#__PURE__*/_jsxs(StyledSection, {
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management-creation.createEmailPanel.selectEmailType"
        })
      }), emailCreationTypes.map(emailType => {
        return /*#__PURE__*/_jsx(EmailOptionButton, {
          emailOption: emailType,
          onClick: setSelectedOption,
          isSelected: selectedOption === emailType.type
        }, emailType.type);
      })]
    })]
  });
}